module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Bold-Italic.5d703e21.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Bold-Italic.woff
// module id = 2323
// module chunks = 50